(function() {
  function initCustomFields() {
    const customFieldsContainer = document.getElementById('custom-fragrance-fields');
    if (!customFieldsContainer) {
      console.log('Custom fields container not found, retrying...');
      setTimeout(initCustomFields, 200);
      return;
    }
    
    console.log('Custom fields initialized successfully');
    console.log('Container found:', customFieldsContainer);
    
    function toggleCustomFields() {
      let selectedVariantText = '';
      
      const allLabels = document.querySelectorAll('label');
      allLabels.forEach(function(label) {
        const input = document.getElementById(label.getAttribute('for'));
        if (input && input.checked && input.name === 'Set-Type-2') {
          selectedVariantText = label.innerText.trim();
        }
      });
      
      console.log('Selected variant text:', selectedVariantText);
      
      if (selectedVariantText.toLowerCase().includes('individuelle Auswahl')) {
        console.log('Showing custom fields');
        customFieldsContainer.style.cssText = 'display: block !important; margin: 20px 0 !important;';
        console.log('Applied cssText:', customFieldsContainer.style.cssText);
        const textarea = customFieldsContainer.querySelector('textarea');
        if (textarea) textarea.setAttribute('required', 'required');
      } else {
        console.log('Hiding custom fields');
        customFieldsContainer.style.cssText = 'display: none !important;';
        const textarea = customFieldsContainer.querySelector('textarea');
        if (textarea) {
          textarea.removeAttribute('required');
          textarea.value = '';
        }
      }
    }
    
    const variantInputs = document.querySelectorAll('input[name="Set-Type-2"]');
    variantInputs.forEach(function(input) {
      input.addEventListener('change', toggleCustomFields);
    });
    
    setTimeout(toggleCustomFields, 100);
    
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        const isVisible = customFieldsContainer.style.cssText.includes('block');
        if (isVisible) {
          const textarea = customFieldsContainer.querySelector('textarea');
          if (textarea && !textarea.value.trim()) {
            e.preventDefault();
            e.stopPropagation();
            alert('Please add your 8 samples of choice.');
            textarea.style.border = '2px solid #d02e2e';
            textarea.focus();
            return false;
          }
        }
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomFields);
  } else {
    initCustomFields();
  }
})();
